import { render, staticRenderFns } from "./SmallScreen.vue?vue&type=template&id=fea07b70&scoped=true&"
import script from "./SmallScreen.vue?vue&type=script&lang=ts&"
export * from "./SmallScreen.vue?vue&type=script&lang=ts&"
import style0 from "./SmallScreen.vue?vue&type=style&index=0&id=fea07b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea07b70",
  null
  
)

export default component.exports